import { Injectable, signal } from '@angular/core';
import { PalletView } from '../types/pallet-view';
import { Stock } from '../types/stock';
import { StockPostingStorageLocation } from '../types/storage-location';

/** Scan results handed from the page that received them to the page that shows them. */
@Injectable()
export class ScanFlowService {
  readonly selectedStock = signal<Stock | null>(null);
  readonly pallet = signal<PalletView | null>(null);
  readonly storageLocation = signal<StockPostingStorageLocation | null>(null);
}
